import request from '@/utils/request'


// 查询活动信息列表
export function listActivity(query) {
  return request({
    url: '/activity/activity/list',
    method: 'get',
    params: query
  })
}

// 查询活动信息分页
export function pageActivity(query) {
  return request({
    url: '/activity/activity/page',
    method: 'get',
    params: query
  })
}

// 查询活动信息详细
export function getActivity(data) {
  return request({
    url: '/activity/activity/detail',
    method: 'get',
    params: data
  })
}

// 新增活动信息
export function addActivity(data) {
  return request({
    url: '/activity/activity/add',
    method: 'post',
    data: data
  })
}

// 修改活动信息
export function updateActivity(data) {
  return request({
    url: '/activity/activity/edit',
    method: 'post',
    data: data
  })
}

// 删除活动信息
export function delActivity(data) {
  return request({
    url: '/activity/activity/delete',
    method: 'post',
    data: data
  })
}
